<template>
	<v-footer inset absolute :style="getStyleDueToDrawer" padless>
		<v-card style="width: 100%" class="text-center" flat color="transparent">
			<v-row no-gutters justify="center">
				<!-- style="border-top: 1px solid grey" -->
				<v-col cols="12" md="12">
					<v-container class="pt-0" fluid>
						<v-row no-gutters>
							<v-col cols="12" md="4">
								<v-card
									flat
									tile
									color="transparent"
									style="height: 100%"
									:class="{'px-7': $vuetify.breakpoint.lgAndUp, 'px-5': $vuetify.breakpoint.smOnly}"
								>
									<v-card-title primary-title>
										<v-row justify="center">
											<div class="primary--text text-body-1 font-weight-bold">روابط أخرى</div>
										</v-row>
									</v-card-title>
									<v-card-text>
										<v-row class="text-start" dense>
											<v-col cols="12">
												<router-link class="text-subtitle-1 py-0" :to="{ name: 'public-privacy-policy' }">
													<v-icon right color="primary">mdi-gavel</v-icon>
													<span class="primary--text">سياسة الخصوصية والإستخدام</span>
												</router-link>
											</v-col>
											<v-col cols="12">
												<router-link class="text-subtitle-1 py-0" :to="{ name: 'public-about' }">
													<v-icon right color="primary">mdi-information</v-icon>
													<span class="primary--text">من نحن</span>
												</router-link>
											</v-col>
											<v-col cols="12">
												<router-link class="text-subtitle-1 py-0" :to="{ name: 'dashboard-ads-add' }">
													<v-icon right color="primary">mdi-comment-plus-outline</v-icon>
													<span class="primary--text">أعلن معنا</span>
												</router-link>
											</v-col>
											<!-- <v-col cols="12">
												<router-link class="text-subtitle-1 py-0" :to="{ name: 'public-payment-methods' }">
													<v-icon right color="primary">mdi-credit-card-multiple</v-icon>
													<span class="primary--text">الحسابات البنكية</span>
												</router-link>
											</v-col> -->
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>

							<v-col
								cols="12"
								md="4"
							>
							<!-- :style="$vuetify.breakpoint.mdAndUp ? 'border-left: 1px solid grey; border-right: 1px solid grey;' : ''" -->
								<v-card
									flat
									tile
									color="transparent"
									style="height: 100%"
									:class="{'px-7': $vuetify.breakpoint.lgAndUp, 'px-5': $vuetify.breakpoint.smOnly}"
								>
									<v-card-title primary-title>
										<v-row justify="center">
											<h2 class="primary--text text-body-1 font-weight-bold">اتصل بنا</h2>
										</v-row>
									</v-card-title>
									<v-card-text>
										<v-row class="text-start" dense>
											<v-col cols="12">
												<h3 class="text-subtitle-1 py-0">
													<v-icon right color="primary">mdi-cellphone</v-icon>
													<a href="tel:0553924250" class="primary--text">0553924250</a>
												</h3>
											</v-col>
											<v-col cols="12">
												<h3 class="text-subtitle-1 py-0">
													<v-icon right color="primary">mdi-email</v-icon>
													<a href="mailto:K2005hm@gmail.com" class="primary--text">K2005hm@gmail.com</a>
												</h3>
											</v-col>
											<v-col cols="12">
												<router-link class="text-subtitle-1 py-0" :to="{ name: 'dashboard-news-add' }">
													<v-icon right color="primary">mdi-newspaper-plus</v-icon>
													<span class="primary--text">شاركنا بخبر</span>
												</router-link>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>

							<v-col cols="12" md="4">
								<v-card
									flat
									tile
									color="transparent"
									style="height: 100%"
									:class="{'px-7': $vuetify.breakpoint.lgAndUp, 'px-5': $vuetify.breakpoint.smOnly}"
								>
									<v-card-title primary-title>
										<v-row justify="center">
											<h2 class="primary--text text-body-1 font-weight-bold">اشترك معنا</h2>
										</v-row>
									</v-card-title>
									<v-card-text>
										<v-form v-model="valid">
											<v-row class="text-start" dense>
												<v-col cols="12">
													<v-text-field
														v-model="name"
														outlined
														hide-details
														label="الاسم"
														prepend-icon="mdi-account-outline"
														:rules="[rules.required]"
													></v-text-field>
												</v-col>
												<!-- <v-col cols="12">
													<v-text-field
														v-model="phone"
														outlined
														hide-details
														label="الجوال"
														prepend-icon="mdi-cellphone"
													></v-text-field>
												</v-col>-->
												<v-col cols="12">
													<v-text-field
														v-model="email"
														outlined
														hide-details
														label="البريد الإلكتروني"
														prepend-icon="mdi-at"
														:rules="[rules.required, rules.email]"
													></v-text-field>
												</v-col>
											</v-row>
											<v-row justify="center" class="pt-5">
												<v-btn v-if="valid" color="primary" :loading="loading" @click="subscribe">
													<v-icon left>mdi-account-plus-outline</v-icon>
													<span>اشتراك</span>
												</v-btn>
											</v-row>
										</v-form>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>

						<v-row justify="center">
							<v-col cols="12">
								<v-card flat color="transparent">
									<app-contact-us footer></app-contact-us>
									<v-card-text class="text-subtitle-1 primary--text">
										<template v-if="systemInfo">{{ systemInfo.copyRights }}</template>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-container>
				</v-col>
			</v-row>
		</v-card>
	</v-footer>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import clientNotifier from "@/clientNotifier";

export default {
	components: {
		"app-contact-us": require("@/components/general/AppContactUs").default,
	},
	mixins: [rulesMixin],
	data() {
		return {
			loading: false,
			valid: false,
			phone: null,
			email: null,
			name: null
		};
	},
	computed: {
		getStyleDueToDrawer() {
			if (this.$store.state.drawer) {
				if (this.$store.state.mini) {
					return "right: 56px; width: calc(100% - 56px)";
				} else {
					return "right: 256px; width: calc(100% - 256px)";
				}
			} else {
				return "right: 0; width: calc(100% - 0px)";
			}
		},
		systemInfo() {
			return this.$store.state.systemInfo;
		}
	},
	methods: {
		subscribe() {
			this.loading = true;

			var data = {
				email: this.email,
				name: this.name
			};

			clientNotifier
				.post("/api/email/subscribe", data)
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
footer {
	transition-duration: 500ms;
}
</style>